import { render, staticRenderFns } from "./DateSwitch.vue?vue&type=template&id=28739442"
import script from "./DateSwitch.vue?vue&type=script&lang=js"
export * from "./DateSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports